import eyekaCover from '../assets/eyekaCover.jpg';
import margotitaCover from '../assets/margotitaCover.png';
import mt01 from '../assets/mt01.jpg';
import mt02 from '../assets/mt02.jpg';
import mt03 from '../assets/mt03.jpg';
import mt04 from '../assets/mt04.jpg';
import mt05 from '../assets/mt05.jpg';
import mt06 from '../assets/mt06.jpg';
import mt07 from '../assets/mt07.jpg';
import mt08 from '../assets/mt08.jpg';
import mt09 from '../assets/mt09.jpg';
import eyekaLogo from '../assets/eyekaLogoB.png';
import marques from '../assets/marques.jpg';
import eyeka01 from '../assets/eyeka01.jpg';
import MTLogo from '../assets/MTLogo.png';
import ww from '../assets/ww.jpg';
import ww1 from '../assets/ww1.jpg';
import ww2 from '../assets/ww2.jpg';
import ww3 from '../assets/ww3.jpg';
import ww4 from '../assets/ww4.jpg';
import WWLogo from '../assets/WWlogoB.png';
import vitalecode from '../assets/vitalecode.jpg';
import vitalecodeLogo from '../assets/vitalecodeLogo.png';
import vitalecodeFlyer from '../assets/vitalecodeFlyer.jpg';
import vitalecodePackaging from '../assets/vitalecodePackaging.jpg';
import vitalcodeTri from '../assets/vitalcodeTri.jpg';
import ofCover from '../assets/of2.jpg';
import ofImg from '../assets/of.jpg';
import ofLogo from '../assets/of.png';
import of1 from '../assets/of1.jpg';
import of3 from '../assets/of3.jpg';
import webImg from '../assets/web.jpg';
import webLogo from '../assets/webLogo.png';
import p06 from '../assets/p06.jpg';
import logoCaptainMorgan from '../assets/captain.png';
import logoHeineken from '../assets/heineken.png';
import logoNike from '../assets/logoNike.png';
import logoNintendo from '../assets/nintendoLogo.png';
import logoOreo from '../assets/oreoLogo.png';
import logoStanSmith from '../assets/logoStanS.png';
import logosCover from '../assets/logoCover.jpg';
import logosAdeva from '../assets/adeva.png';
import logosBuzzz from '../assets/buzzz.png';
import logosWebbisterie from '../assets/lawebbisterie.png';
import logosLeCocon from '../assets/logo-le-cocon.png';
import logosRoundnet from '../assets/logo-roundnet.png';
import logosSylmaps from '../assets/sylmaps.png';
import logosTriviacar from '../assets/triviacar.png';
import logosConfiserie from '../assets/confiserie-delgado.jpg';
import logosDeltaDep from '../assets/delta-dep.jpg';
import logosERando from '../assets/e-rando.jpg';
import logosFastTips from '../assets/fast-tips.jpg';
import logosTontonHappy from '../assets/tonton-happy.jpg';
import logosTraceMedia from '../assets/trace-media.jpg';
import logosEyeka from '../assets/eyeka.jpg';
import logosOceansfishing from '../assets/oceansfishing.jpg';
import logosRevanove from '../assets/revanove.jpg';
import logosWahineWay from '../assets/wahine-way.jpg';
import imgUtips1 from '../assets/imgUtips1.jpg';
import imgUtips2 from '../assets/imgUtips2.jpg';
import logoUtips from '../assets/logoUtips.png';
import badgeAppStore from '../assets/badgeAppStore.png';
import badgeGooglePlay from '../assets/badgeGooglePlay.png';
import pg01 from '../assets/pg01.jpg';
import pg02 from '../assets/pg02.jpg';
import pg03 from '../assets/pg03.jpg';
import pg04 from '../assets/pg04.jpg';
import logoPg from '../assets/logo-pg.png';
import erandoImg from '../assets/erando.jpg';
import logoErando from '../assets/logoErando.png';
import captainMorgan from '../assets/captain-morgan.jpg';
import dimChris from '../assets/dim-chris-feat-craig-david.jpg';
import heineken from '../assets/heineken.jpg';
import nikeAirMax from '../assets/nike-air-max.jpg';
import nikePhenom from '../assets/nike-phenom.jpg';
import nintendo from '../assets/nintendo.jpg';
import oreo from '../assets/oreo.jpg';
import retroIsBetter from '../assets/retro-is-better.jpg';
import stanSmith from '../assets/stan-smith.jpg';

export const tags = ['Branding', 'UI/UX Design', 'Web & Mobile Design', 'Direction Artistique', 'Graphic Design'];

const projects = [
  {
    id: '01',
    slug: 'eyeka',
    title: 'eYeka',
    logo: eyekaLogo,
    img: eyekaCover,
    year: '2015–2020',
    category: 'Brand Identity & UI/UX',
    tags: ['Branding', 'Brandbook', 'UI/UX Design', 'Web & Mobile Design', 'Direction Artistique', 'Graphic Design'],
    gallery: [eyeka01, eyekaCover, marques],
    description: `eYeka est le leader européen du crowdsourcing créatif, une plateforme qui met en relation les plus grandes marques mondiales avec une communauté internationale de créatifs. Pendant sept ans, j'y ai occupé un rôle central autour de l'identité de marque et de l'expérience digitale, en lien étroit avec les équipes marketing et techniques.\n\nJ'ai piloté la refonte complète de l'identité visuelle de la plateforme — brandbook, charte graphique, interfaces web et mobile — avec pour exigence constante de maintenir une cohérence forte entre l'image de marque et l'expérience utilisateur. En parallèle, j'ai conçu plus de 800 créations pour des campagnes impliquant plus de 500 marques internationales, parmi lesquelles P&G, Unilever, Nestlé, Danone et PepsiCo.\n\nCette expérience m'a permis de développer une pratique du design à la fois rigoureuse et polyvalente, où direction artistique, UI/UX et stratégie de marque s'articulent naturellement pour servir des enjeux de communication ambitieux.`,
  },
  {
    id: '02',
    slug: 'margot-tita',
    title: 'Margot & Tita',
    logo: MTLogo,
    logoHeight: 50,
    img: margotitaCover,
    year: '2019',
    category: 'Identité Visuelle',
    tags: ['Branding', 'UI/UX Design', 'Direction Artistique', 'Graphic Design'],
    gallery: [mt01, mt02, mt03, mt04, mt05, mt06, mt07, mt08, mt09],
    description: `Margot & Tita est une marque de parfums et de cosmétiques dont l'univers repose sur l'élégance, la féminité et l'émotion. Dans le cadre de cette collaboration, j'ai accompagné la marque sur l'ensemble de son identité visuelle afin de garantir une expérience cohérente sur tous les points de contact.\n\nMa mission a couvert la création et l'évolution du branding, le développement des packagings produits, la conception des différents supports de communication graphique ainsi que le design UI/UX des interfaces digitales. L'objectif était de renforcer la personnalité de la marque, valoriser ses produits et offrir une expérience utilisateur fluide, immersive et en parfaite adéquation avec son positionnement premium.\n\nÀ travers ce projet, j'ai travaillé à la construction d'un écosystème visuel global où chaque détail, du packaging à l'interface digitale, participe à raconter l'histoire de la marque et à enrichir l'expérience client.`,
  },
  {
    id: '03',
    slug: 'vital-ecode',
    title: 'Vital eCode',
    logo: vitalecodeLogo,
    logoHeight: 41,
    img: vitalecode,
    year: '2021',
    category: 'UI Design',
    tags: ['Branding', 'UI/UX Design', 'Web & Mobile Design', 'Direction Artistique', 'Graphic Design'],
    description: `Vitalecode est une solution de santé connectée primée au Concours Lépine, conçue pour faciliter l'accès aux informations médicales en situation d'urgence grâce à un QR code intégré à des bracelets, pendentifs et vêtements.\n\nMa mission a consisté à imaginer et concevoir l'ensemble de l'écosystème de marque, depuis le produit jusqu'à l'expérience digitale. J'ai assuré la direction artistique du projet, le design des objets connectés, la création des packagings, l'identité visuelle et les différents supports de communication. J'ai également conçu l'expérience utilisateur ainsi que les interfaces du site web et de l'application mobile afin de proposer un parcours simple, rassurant et accessible à tous.\n\nL'objectif était de transformer une innovation technologique en une marque crédible, humaine et facilement identifiable, capable de créer un lien de confiance entre les utilisateurs, les proches et les professionnels de santé.`,
    gallery: [vitalcodeTri, vitalecode, vitalecodeFlyer, vitalecodePackaging],
  },
  {
    id: '04',
    slug: 'wahine-wai',
    title: 'Wahine Wai',
    logo: WWLogo,
    logoHeight: 104,
    img: ww3,
    year: '2020',
    category: 'Branding & Webdesign',
    tags: ['Branding', 'Direction Artistique', 'Packaging', 'Product Designer', 'Graphic Design'],
    gallery: [ww, ww1, ww2, ww3, ww4],
    description: `Wahine Wai est une marque de maillots de bain féminine ancrée dans la culture surf. J'ai conçu pour eux leur identité visuelle, le logo, et les premiers modèles de maillot de bain et accessoires, en cherchant à capturer cet équilibre entre féminité, liberté et esprit océan qui définit l'ADN de la marque.`,
  },
  {
    id: '05',
    slug: 'oceans-fishing',
    title: 'Oceans Fishing',
    logo: ofLogo,
    logoHeight: 56,
    img: ofCover,
    year: '2021',
    category: 'Branding',
    gallery: [of1, ofCover, of3, ofImg],
    description: `Oceans Fishing est une marque spécialisée dans le vêtement technique pour la pêche sportive. J'ai accompagné la marque dès ses débuts en prenant en charge l'ensemble de sa dimension créative : conception du logo, charte graphique, mais aussi les premiers designs de vêtements et accessoires, le webdesign et les supports de communication.\n\nUn projet complet et engageant, qui m'a demandé de conjuguer identité de marque forte, contraintes techniques liées au vêtement sportif et univers visuel cohérent — du produit jusqu'à la communication digitale.`,
  },
  {
    id: '06',
    slug: 'la-webbisterie',
    title: 'La Webbisterie',
    logo: webLogo,
    logoHeight: 84,
    img: webImg,
    year: '2022',
    category: 'Direction Artistique',
    gallery: [webImg],
    description: `La Webbisterie est une agence spécialisée dans la création de sites internet, pour laquelle j'ai intervenu en tant que prestataire freelance pendant plusieurs années. Ma mission s'articulait principalement autour de deux axes : la création d'identités visuelles et le webdesign.\n\nJ'ai conçu pour leurs clients des logos et chartes graphiques adaptés à des secteurs et des univers variés, en veillant à traduire fidèlement le positionnement de chaque marque. En parallèle, j'ai assuré la conception graphique de leurs sites web, en proposant des interfaces claires, cohérentes et pensées pour l'expérience utilisateur.\n\nCette collaboration m'a permis de travailler dans un contexte d'agence, au rythme des briefs clients et des contraintes de production, tout en affinant ma capacité à produire des livrables graphiques solides et adaptés à des besoins digitaux concrets.`,
  },
  {
    id: '07',
    slug: 'logos',
    title: 'Logos',
    img: logosCover,
    year: '2015–2024',
    category: 'Branding',
    tags: ['Création logotypes', 'Graphic Design'],
    gallery: [logosAdeva, logosBuzzz, logosWebbisterie, logosLeCocon, logosRoundnet, logosSylmaps, logosTriviacar, logosConfiserie, logosDeltaDep, logosERando, logosFastTips, logosTontonHappy, logosTraceMedia, logosEyeka, logosOceansfishing, logosRevanove, logosWahineWay],
    description: `Depuis plus de 15 ans, la création de logos et d'identités visuelles est au cœur de ma pratique. Chaque projet est une occasion de traduire graphiquement l'essence d'une marque — ses valeurs, son univers, sa personnalité — en un signe fort et mémorable. Voici un aperçu de quelques réalisations, reflet d'une diversité de secteurs et de styles travaillés au fil des années.`,
  },
  {
    id: '08',
    slug: 'utips',
    title: 'Utips',
    logo: logoUtips,
    logoHeight: 60,
    img: imgUtips2,
    year: '2026',
    category: 'Branding & UI/UX Design',
    tags: ['Branding', 'UI/UX Design', 'Web & Mobile Design', 'Direction Artistique', 'Graphic Design'],
    gallery: [imgUtips1, imgUtips2],
    description: `Utips est une application mobile qui permet de recevoir et donner des pourboires en toute simplicité, grâce à un simple QR code. Plus qu'un pourboire, une marque de reconnaissance.\n\nJ'ai conçu l'identité de marque ainsi que l'ensemble de l'expérience UI/UX de l'application — logo, charte graphique, interfaces et parcours utilisateur — en visant une expérience simple, humaine et moderne, pensée pour créer des connexions plus vraies entre les gens.`,
    appStoreUrl: 'https://apps.apple.com/app/utips/id6805889887',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.utips.mobile',
    badges: { apple: badgeAppStore, google: badgeGooglePlay },
  },
  {
    id: '09',
    slug: 'pokengo',
    title: 'Pokengo',
    logo: logoPg,
    logoHeight: 90,
    img: pg03,
    year: '2020',
    category: 'Branding',
    gallery: [pg01, pg02, pg03, pg04],
    description: `Pokengo est un restaurant de poké bowl à l'identité volontairement affirmée. J'ai pris en charge l'ensemble de la création de la marque, du logo à la charte graphique, en construisant un univers visuel fort, coloré et cohérent avec l'énergie et la modernité du concept.\n\nAu-delà de l'identité visuelle, j'ai accompagné la marque dans sa communication au sens large : conception des campagnes publicitaires et supports d'affichage, création des visuels événementiels et promotionnels. Un projet complet qui illustre bien ma façon de travailler — construire une marque de A à Z et l'accompagner dans la durée, du naming visuel jusqu'au terrain.`,
  },
  {
    id: '10',
    slug: 'e-rando',
    title: 'E-Rando',
    logo: logoErando,
    img: erandoImg,
    year: '2021',
    category: 'Branding',
    tags: ['Branding', 'Direction Artistique', 'Graphic Design'],
    gallery: [erandoImg],
    description: `E-Rando est une société spécialisée dans la location de trottinettes et motos électriques. J'ai conçu l'ensemble de son identité de marque — logo et charte graphique — en cherchant à traduire visuellement les valeurs qui lui sont propres : mobilité, modernité et éco-responsabilité.\n\nJ'ai également assuré la conception de ses supports de communication, en veillant à maintenir une cohérence forte entre l'identité visuelle et les messages portés par la marque sur l'ensemble de ses canaux.`,
  },
  {
    id: '11',
    slug: 'captain-morgan',
    title: 'Captain Morgan',
    logo: logoCaptainMorgan,
    logoHeight: 28,
    img: captainMorgan,
    year: '2018',
    category: 'Direction Artistique',
    tags: ['Graphic Design'],
    gallery: [captainMorgan],
    description: 'Création graphique en corrélation avec la marque.',
  },
  {
    id: '12',
    slug: 'dim-chris',
    title: 'Dim Chris feat Craig David',
    img: dimChris,
    year: '2018',
    category: 'Direction Artistique',
    tags: ['Graphic Design'],
    gallery: [dimChris],
    description: `Une belle opportunité que celle de contribuer à l'univers visuel d'un single musical. J'ai assuré la conception graphique de la pochette pour Dim Chris en collaboration avec Craig David, en travaillant à créer un visuel à la hauteur de l'identité artistique des deux artistes.`,
  },
  {
    id: '13',
    slug: 'heineken',
    title: 'Heineken',
    logo: logoHeineken,
    logoHeight: 28,
    img: heineken,
    year: '2018',
    category: 'Direction Artistique',
    tags: ['Graphic Design'],
    gallery: [heineken],
    description: 'Création graphique en corrélation avec la marque.',
  },
  {
    id: '14',
    slug: 'nike-air-max',
    title: 'Nike Air Max',
    logo: logoNike,
    logoHeight: 56,
    img: nikeAirMax,
    year: '2018',
    category: 'Direction Artistique',
    tags: ['Graphic Design'],
    gallery: [nikeAirMax],
    description: 'Création graphique en corrélation avec la marque.',
  },
  {
    id: '15',
    slug: 'nike-phenom',
    title: 'Nike Phenom',
    logo: logoNike,
    logoHeight: 56,
    img: nikePhenom,
    year: '2018',
    category: 'Direction Artistique',
    tags: ['Graphic Design'],
    gallery: [nikePhenom],
    description: 'Création graphique en corrélation avec la marque.',
  },
  {
    id: '16',
    slug: 'nintendo',
    title: 'Nintendo',
    logo: logoNintendo,
    img: nintendo,
    year: '2018',
    category: 'Direction Artistique',
    tags: ['Graphic Design'],
    gallery: [nintendo],
    description: 'Création graphique en corrélation avec la marque.',
  },
  {
    id: '17',
    slug: 'oreo',
    title: 'Oreo',
    logo: logoOreo,
    img: oreo,
    year: '2018',
    category: 'Direction Artistique',
    tags: ['Graphic Design'],
    gallery: [oreo],
    description: 'Création graphique en corrélation avec la marque.',
  },
  {
    id: '18',
    slug: 'retro-is-better',
    title: 'Retro Is Better',
    img: retroIsBetter,
    year: '2018',
    category: 'Direction Artistique',
    tags: ['Graphic Design'],
    gallery: [retroIsBetter],
    description: 'Création graphique en corrélation avec la marque.',
  },
  {
    id: '19',
    slug: 'stan-smith',
    title: 'Stan Smith',
    logo: logoStanSmith,
    logoHeight: 56,
    img: stanSmith,
    year: '2018',
    tags: ['Graphic Design'],
    category: 'Direction Artistique',
    gallery: [stanSmith],
    description: 'Création graphique en corrélation avec la marque.',
  },
];

export default projects;
